import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
    1: {
        // Exercise num
        unit: 'Unit 6',
        id: 'WB3-U6-P45-E1',
        audio: "",
        video: "",
        component: T6,
        exerciseKey: "img/FriendsPlus/Page45/E1/Key/answerKey.png",
        inputSize: 150,
        checkUppercase: true,
        titleImage: "img/FriendsPlus/Page45/E1/title.jpg",
        // titleQuestion: [{ color: '#3F3478', num: '2', title: "Write yes or no." }],
        questionImage: [],
        questions: [
            {
                title: `
              <div >
                  <div><b>1 </b><u style='color: gray;'><i> What's</i></u>  your name? My name is Khang. </div>
                  <div><b>2</b># his teddy bear? His teddy bear is in his bedroom.</div>
                  <div><b>3</b># do you have P.E.? On Tuesday.</div>
                  <div><b>4</b> # does she like?  She likes candy. </div>
                  <div><b>5</b> # does she get up at eighr o'clock</div>
              </div>
            `,
                answer: ["Where's", "When", "What", "When"],
            },
        ],
    },

    2: {
        unit: 'Unit 6',
        id: 'WB3-U6-P45-E2',
        audio: '',
        video: '',
        component: UI,
        titleImage: '',
        question: [
        ],
        questionImage: [
            [
                { url: 'img/FriendsPlus/Page45/E2/1.jpg' },
            ],
            [
                { url: 'img/FriendsPlus/Page45/E2/2.jpg' },
            ],
        ]
    },
    3: { // Exercise num
        unit: 'Unit 6',
        id: 'WB3-U6-P45-E3',
        audio: '',
        video: '',
        component: D1,
        hideBtnFooter: true,
        // recorder: true,
        isAllowSubmit: false,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page45/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page45/E3/2.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page45/E3/3.jpg' },
                { url: 'img/FriendsPlus/Page45/E3/4.jpg', input: true, answer: "" },
                { url: 'img/FriendsPlus/Page45/E3/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page45/E3/6.jpg' },
                { url: 'img/FriendsPlus/Page45/E3/7.jpg', input: true, answer: "" },
                { url: 'img/FriendsPlus/Page45/E3/8.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page45/E3/9.jpg' },
                { url: 'img/FriendsPlus/Page45/E3/10.jpg', input: true, answer: "" },
                { url: 'img/FriendsPlus/Page45/E3/11.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page45/E3/12.jpg' },
                { url: 'img/FriendsPlus/Page45/E3/13.jpg', input: true, answer: "" },
                { url: 'img/FriendsPlus/Page45/E3/14.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page45/E3/15.jpg' },
                { url: 'img/FriendsPlus/Page45/E3/16.jpg', input: true, answer: "" },
                { url: 'img/FriendsPlus/Page45/E3/17.jpg' },
            ],
            [
                // Column8
                { url: 'img/FriendsPlus/Page45/E3/18.jpg' },
            ],


        ],
    },



}

export default json;